import PropTypes from 'prop-types';
export const popupListPropTypes = {
  heading: PropTypes.string,
  items: PropTypes.array
};